import { styled } from '../../../../shared/styled-components'

export const ColumnHeadline = styled.h2`
  border-bottom: 2px solid ${(props) => props.theme.greenColor};
  font-size: 20px;
  font-weight: bold;
`
